(function() {
  'use strict';

  function InsuranceDialogCtrl ($mdDialog, ShippingConfig) {
    var ctrl = this;
    ctrl.isLoading = true;
    ShippingConfig.getOptions()
      .then(function (data) {
        ctrl.isLoading = false;
        ctrl.maxValue = _.reduce(data, function(accumulator, value){
          return accumulator >= value.valorDeclaradoMaximo ? accumulator : value.valorDeclaradoMaximo;
        }, 0);
      });
    ctrl.close = function () {
      $mdDialog.cancel();
    };
    ctrl.formSubmit = function (form) {
      $mdDialog.hide({
        insurance: form.insurance.$modelValue,
      });
    };
  }

  angular
    .module('mandaeApp')
    .controller('InsuranceDialogCtrl', InsuranceDialogCtrl);

}());
